import React from "react";
import { Box } from "@mui/material";
import "../../assets/settings.scss";
import { Link, useNavigate } from "react-router-dom";
import { taskAlt } from "../images";
import Text from "../text/Text";
import {
  backToHome,
  requestSubmitted,
  requestSubmittedInfo,
  supportMail,
} from "../messages";
import Button from "../button/Button";

function RequestSubmitted() {
  const navigate = useNavigate();

  return (
    <Box className="options-container">
      <Box className="request-submitted-wrapper" marginTop={0} height="96vh">
        <Box sx={{ backgroundColor: "white" }}>
          <Box className="module-container" textAlign="center">
            <img
              src={taskAlt}
              height="54px"
              width="54px"
              style={{ marginBottom: "16px" }}
            />
            <Text className="default-text" size={22} font="bold">
              {requestSubmitted}
            </Text>
            <Text className="grey-text" size={16} font="regular">
              {requestSubmittedInfo[0]}
              <Link>{supportMail}</Link>
              {requestSubmittedInfo[1]}
            </Text>
          </Box>
          <Box
            className="options-footer-btn"
            sx={{ display: "flex", justifyContent: "space-around" }}
          >
            <Button
              fullWidth
              variant="contained"
              label={backToHome}
              onClick={() => navigate("/wallet")}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default RequestSubmitted;
